import { ActionFunction, redirect } from 'react-router-dom';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import { submitMutation } from '~/api/data/responses';
import {
  CreateIntegrationDocument,
  CreateIntegrationMutation,
  CreateIntegrationMutationVariables
} from '~/api/graphql';

export const createIntegration = (variables: CreateIntegrationMutationVariables) =>
  mutateData<CreateIntegrationMutation, CreateIntegrationMutationVariables>(client, {
    mutation: CreateIntegrationDocument,
    variables
  });

export const submitCreateIntegration: ActionFunction = async ({ request }) =>
  submitMutation(createIntegration({ input: await request.json() }), async (data) =>
    redirect(`/app/settings/integrations/manage/${data?.createIntegration?.id}`)
  );
